import apiPaths from '../api-paths';

const baseUrl = `${ apiPaths.CRM }/template-basic-price-list-type`;

export default {
  index() {
    return axios.get(`${ baseUrl }`);
  },
};
